import { render } from "./SearchSuLatestInfoModal.vue?vue&type=template&id=e275b6a4"
import script from "./SearchSuLatestInfoModal.vue?vue&type=script&lang=js"
export * from "./SearchSuLatestInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__